import React from "react";
import { ControlPosition, MapControl } from "@vis.gl/react-google-maps";
import { Link } from "react-router-dom";

// Map controls sidebar component
export default function MapRouteSidebar({
  children,
  noLink = false,
  title,
  footer,
}: {
  children: React.ReactNode;
  noLink?: boolean;
  title: string;
  footer?: React.ReactNode;
}) {
  return (
    <MapControl position={ControlPosition.TOP_LEFT}>
      <div id="map-route-sidebar">
        <div className="m-2 bg-white bg-opacity-90 px-5 py-3 rounded-xl shadow text-base w-48">
          {!noLink && (
            <Link to="..">
              <button className="text-xs mb-5 text-gray-600 font-semibold hover:underline">
                &lt; Back to Map
              </button>
            </Link>
          )}
          <h3 className="text-lg font-semibold mb-2">{title}</h3>
          {children}
        </div>
        {footer ? footer : null}
      </div>
    </MapControl>
  );
}

export const MapRouteDelete = ({ onDelete }: { onDelete: () => void }) => {
  return (
    <div className="mt-5">
      <button
        className="text-sm border border-gray-300 bg-white py-1 px-2 rounded hover:bg-gray-200 hover:border-gray-400"
        onClick={onDelete}
      >
        Delete
      </button>
    </div>
  );
};
